import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const ErrorSnackbar = ({ open, onClose, message, severity }) => {
    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Alert
                onClose={onClose}
                severity={severity}
                sx={{
                    width: '100%',
                    fontSize: '0.9rem',
                    padding: '0.7rem',
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default ErrorSnackbar;
